import type { Option } from 'payload'

// Marks a visit that arrived via the desktop-handoff email, so the front-end can
// tell it apart from a cold visit (and handle a re-open back on mobile).
export const DESKTOP_CLAIM_SOURCE = 'desktopClaimEmail'

export enum EligibilityOption {
  PreSignup = 'PreSignup',
  FreeUser = 'FreeUser',
  Everyone = 'Everyone',
}

const eligibilityOptionLabel = {
  [EligibilityOption.PreSignup]: 'Pre-Signup Only',
  [EligibilityOption.FreeUser]: 'Free Users Eligible',
  [EligibilityOption.Everyone]: 'Everyone Eligible',
}

export const dealEligibilityOptions: Option[] = [
  {
    label: eligibilityOptionLabel[EligibilityOption.PreSignup],
    value: EligibilityOption.PreSignup,
  },
  {
    label: eligibilityOptionLabel[EligibilityOption.FreeUser],
    value: EligibilityOption.FreeUser,
  },
  {
    label: eligibilityOptionLabel[EligibilityOption.Everyone],
    value: EligibilityOption.Everyone,
  },
] as const satisfies Option[]

export enum DealType {
  Percent = 'percent',
  Currency = 'currency',
  Days = 'days',
  Other = 'other',
}

const dealTypeLabel = {
  [DealType.Percent]: 'Percent (% off)',
  [DealType.Currency]: 'Currency ($ off in USD)',
  [DealType.Days]: 'Days (Trial)',
  [DealType.Other]: 'Other (Name)',
}

export const dealUnitOptions: Option[] = [
  {
    label: dealTypeLabel[DealType.Percent],
    value: DealType.Percent,
  },
  {
    label: dealTypeLabel[DealType.Currency],
    value: DealType.Currency,
  },
  {
    label: dealTypeLabel[DealType.Days],
    value: DealType.Days,
  },
  {
    label: dealTypeLabel[DealType.Other],
    value: DealType.Other,
  },
] as const satisfies Option[]
